import { BaseModel } from "sjs-base-model";
import UserDataModel from "./UserDataModel";

export default class UserModel extends BaseModel {
  //USER model
  _shards = {};
  current_page_no = 0;
  hits = {};
  total_page_no = 0;
  timed_out = false;
  took = 0;
  constructor(data1) {
    super();

    this.update(data1);
  }
}
